import * as THREE from 'three'
import { useRef, useState, useMemo } from 'react'
import { useThree } from '@react-three/fiber'
import { getMousePositionNormalized } from '../Utils'

export function RaycastPlane({
    position = [0, 0, 0],
    rotation = [0, 0, 0],
    size = [10, 10],
    setCollisionPoint
}) {
    const { camera } = useThree()
    const planeRef = useRef()

    const raycaster = useRef(new THREE.Raycaster())
    const mouse = useRef(new THREE.Vector2())
    const [spherePosition, setSpherePosition] = useState(new THREE.Vector3())

    const handlePointerMove = (event) => {
        // console.log("handlePointerMove")
        // Calculate mouse position in normalized device coordinates (-1 to +1) for both components
        const mousePosition = getMousePositionNormalized(event)
        mouse.current.x = mousePosition.x
        mouse.current.y = mousePosition.y

        // Update the picking ray with the camera and mouse position
        raycaster.current.setFromCamera(mouse.current, camera)

        // Calculate objects intersecting the picking ray
        const intersects = raycaster.current.intersectObject(planeRef.current)

        if (intersects.length > 0) {
            // Get the intersection point
            const intersection = intersects[0]
            // console.log('Intersection:', intersection.object)
            const intersectionPoint = intersection.point
            // console.log('Intersection point:', intersectionPoint)
            setCollisionPoint(intersectionPoint)
            setSpherePosition(intersectionPoint)
        }
    }

    const [planeGeometry, planeMaterial] = useMemo(() => {
        return [
            new THREE.PlaneGeometry(...size),
            new THREE.MeshBasicMaterial({
                transparent: true,
                opacity: 2.0,
            })
        ]
    }, [size])

    return (
        <>
            <mesh
                ref={planeRef}
                name="plane"
                onPointerMove={handlePointerMove}
                geometry={planeGeometry}
                material={planeMaterial}
                position={position}
                rotation={rotation}
                visible={false}
            />

            <mesh
                name="sphere"
                position={spherePosition}
                visible={false}
            >
                <sphereGeometry args={[0.2, 32, 32]} />
                <meshStandardMaterial color="#ffffff" />
            </mesh>
        </>
    )
} 